// src/components/AboutPage.tsx
import React from "react";
import Footer from "../components/Footer";

const BookingVerifyPage: React.FC = () => {
  return (
    <div>
      <div>
        <h1>BookingVerifyPage</h1>
        {/* Add your content here */}
      </div>
      <Footer></Footer>
    </div>
  );
};

export default BookingVerifyPage;
